var Log = require('./log')

module.exports = exports = Log.getLogger() // export default logger
